<template>
<span>

      <v-text-field
          @click:clear="returnsContactListWhenCleared"
          clearable
          class="mt-2 mb-2"
          dense
          hide-details
          outlined
          v-model="search"
          placeholder="Search Contact"
          prepend-inner-icon="mdi-magnify"
          v-on:keyup.enter="searchContactData"
          @keyup="returnsContactListWhenNull"
      ></v-text-field>


            <v-divider></v-divider>


  <div
      ref="contactScroller"
      class="list-scroller"
      @scroll="onScroll"
      @wheel="onWheel"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
  >
 <v-progress-linear
     v-if="contactLoader"
     indeterminate
     color="#242f7e"
     class="mb-0"
     height="2"
 ></v-progress-linear>
                <v-list
                    v-for="item in contactList"
                    :key="item.number"
                    subheader
                >

                  <v-list-item-group
                      :v-model="item.number"
                  >

                    <v-list-item
                        style="border-bottom: 0.5px solid #f1f1f1;"
                        @click.prevent="selectUserContact(item)"
                        link>

                      <v-list-item-avatar>
                        <v-icon large>
                          mdi-account-circle
                        </v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                        <small v-text="item.phone"></small>
                      </v-list-item-content>

                      <v-list-item-action>


                         <v-menu
                             bottom
                             left
                             open-on-hover
                         >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                      <v-card width="180">
                          <v-list dense>
                            <v-list-item @click="editContact(item)">
                              <small>Edit Contact</small>
                            </v-list-item>
                          </v-list>
                      </v-card>
                        </v-menu>

        </v-list-item-action>

                    </v-list-item>

                  </v-list-item-group>

                </v-list>

      <div v-if="loadFailed" class="load-more-wrap">
        <button
            type="button"
            class="load-more-btn"
            :disabled="contactLoader"
            @click.stop="retryContactLoad"
        >
          Load more
        </button>
      </div>

  </div>


 <v-dialog
     transition="dialog-bottom-transition"
     v-model="editUserDialog"
     width="42%"
 >

      <v-card>
         <v-toolbar dense flat>
          <v-toolbar-title>Edit User</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-icon
                color="red"
                @click="editUserDialog = false"
            >
             mdi-close
            </v-icon>
         </v-toolbar>
        <v-divider></v-divider>

         <v-card class="mx-auto pb-4 mt-6" width="96%" flat>

           <new-user :userInfo="userInfo" ref="edit_user_component"></new-user>

         </v-card>


      </v-card>
    </v-dialog>


</span>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import NewUser from "@/views/Main/users/NewUser";

export default {
  name: "MessengerContacts",
  components: {NewUser},
  data(){
    return{
      contactLoader:false,
      loadFailed:false,
      scrollReady:true,
      loadedScrollHeight:0,
      hasMoreContacts:true,
      search:"",
      contactList:[],
      items_per_page: 14,
      page: 1,
      pendingPage: 1,
      touchStartY: 0,
      editUserDialog:false,
      userInfo:{}
    }
  },
  mounted() {
    if(this.$route.query.q){
      this.search = this.$route.query.q
    }
    this.fetchContacts()
    this.connectedCompanyPhones()
  },
  methods: {
    ...mapActions(
        [
          "fetchContactList",
            "contactMessageList",
            "fetchContactProfile",
            "connectedCompanyPhones"
        ]
    ),
    fetchContacts(){
      this.contactList = []
      this.page = 1
      this.hasMoreContacts = true
      this.loadFailed = false
      this.scrollReady = true
      this.loadedScrollHeight = 0
      this.contactLoader = false
      this.loadContactPage(1)
    },
    retryContactLoad(){
      this.loadFailed = false
      this.contactLoader = false
      this.loadContactPage(this.pendingPage || 1)
    },
    loadContactPage(page){
      if (this.contactLoader || !this.hasMoreContacts) {
        return
      }
      if (page > 1 && !this.contactsListIsVisible()) {
        return
      }
      this.contactLoader = true
      this.pendingPage = page
      this.fetchContactList({
        page: page,
        per_page: this.items_per_page,
        search: this.search,
      })
    },
    selectUserContact(item) {
      let options = {
        page: 1,
        per_page: 11,
        contact_number: item.number,
       // search: this.search,
      }
      this.contactMessageList(options)

      //  fetch user contact profile
      this.fetchContactProfile(item.number)

      // router.push({name: 'messenger', query: {type: 'contacts', id: item.number, page: this.page+'', per_page: this.items_per_page+''}})
    },
    filterContactData(data) {
      let dataObj = data.data || [];
      let current_page = (data.page * 1);
      if (current_page > 0 && this.pendingPage && current_page !== this.pendingPage) {
        return
      }
      this.page = current_page > 0 ? current_page : 1;
      this.hasMoreContacts = dataObj.length >= this.items_per_page;
      this.loadFailed = false

      let per_page = data.per_page;
      this.items_per_page = (per_page * 1) || this.items_per_page;

      this.contactLoader = false;


      let jsn = {};
      // let arr = [];

      dataObj.forEach(list => {
        let user = list.User || {}
        jsn = {
          title: user.surname + " " + user.second_name + " " + user.other_names,
          phone: list.contact,
          number: list.number,
          userNumber: user.number,
        }
        //arr.push(jsn)

        const index = this.contactList.findIndex(object => object.number === jsn.number);

        if (index === -1) {
          this.contactList.push(jsn);
        }

      })
    },
    contactsListIsVisible() {
      return this.$route.query.type !== "grp"
    },
    onScroll(event) {
      const target = event && event.target ? event.target : null
      this.requestNextPage(target, false)
    },
    onWheel(event) {
      if (!event || event.deltaY <= 0) {
        return
      }
      this.requestNextPage(this.$refs.contactScroller, true)
    },
    onTouchStart(event) {
      const touch = event.touches && event.touches[0]
      this.touchStartY = touch ? touch.clientY : 0
    },
    onTouchMove(event) {
      const touch = event.touches && event.touches[0]
      if (!touch || this.touchStartY - touch.clientY < 12) {
        return
      }
      this.requestNextPage(this.$refs.contactScroller, true)
    },
    requestNextPage(target, fromUserGesture) {
      if (!this.contactsListIsVisible() || !target || this.contactLoader || !this.hasMoreContacts || this.loadFailed) {
        return
      }
      if (target.clientHeight < 40) {
        return
      }
      const distanceFromBottom = target.scrollHeight - (target.scrollTop + target.clientHeight)
      if (distanceFromBottom > 160) {
        this.scrollReady = true
        return
      }
      if (target.scrollHeight <= this.loadedScrollHeight) {
        return
      }
      if (!fromUserGesture && (target.scrollTop <= 0 || !this.scrollReady)) {
        return
      }
      this.scrollReady = false
      this.loadedScrollHeight = target.scrollHeight
      this.loadContactPage(this.page + 1)
    },
    searchContactData(){
      this.contactList = []
      this.page = 1
      this.hasMoreContacts = true
      this.loadFailed = false
      this.scrollReady = true
      this.loadedScrollHeight = 0
      this.contactLoader = false
      this.loadContactPage(1)
    },
    editContact(item){
      this.editUserDialog = true
      this.userInfo = {number: item.userNumber}
    },
    returnsContactListWhenNull(){
      if(!this.search){
        this.searchContactData()
      }
    },
    returnsContactListWhenCleared(){
     this.search = ""
      this.searchContactData()
    }


  },
  computed:{
    ...mapGetters(
        [
          "getContactList",
          "getNewContactError",
          "getEditUserInfo"
        ]
    )
  },
  watch:{
    getContactList(data){
      if(data){
        if (data) {
          this.filterContactData(data)

          //if no contact is selected then with use the first contact to display its data
       if(data.page === 1 && this.contactList.length) {
         if(this.$route.query.type !== 'grp') {
           let profileNumber = this.contactList[0].number
           this.selectUserContact({number: profileNumber})
         }
       }

        }
      }
    },
    getNewContactError(data){
      if(data && this.contactLoader){
        this.contactLoader = false
        this.loadFailed = true
        this.scrollReady = true
      }
    },
    getEditUserInfo(data){
      if(data){
        this.$refs["edit_user_component"].spinner = false
        this.$refs["edit_user_component"].form = {
          surname: null,
          second_name: null,
          other_names: null,
          email: [
            {mail:null, number: null}
          ],
          phone: [
            {phoneNumber:null, number: null}
          ],
          gender: null,
        }
        this.fetchContacts()
        this.successToast("Success", data.message)
        this.editUserDialog = false
      }
    }
  }
}
</script>

<style scoped>
.list-scroller {
  height: 70vh;
  overflow-y: auto;
}
.load-more-wrap {
  display: flex;
  justify-content: center;
  padding: 12px 0 16px;
}
.load-more-btn {
  border: 1px solid #242f7e;
  background: transparent;
  color: #242f7e;
  border-radius: 999px;
  padding: 6px 16px;
  font-size: 12px;
  cursor: pointer;
}
.load-more-btn:disabled {
  opacity: 0.55;
  cursor: default;
}
.activeClass{
  background-color: #e4e4e4;
}
</style>